import { render } from "./paymentOptionCard.vue?vue&type=template&id=089d9b9c"
import script from "./paymentOptionCard.vue?vue&type=script&lang=js"
export * from "./paymentOptionCard.vue?vue&type=script&lang=js"

import "./paymentOptionCard.vue?vue&type=style&index=0&id=089d9b9c&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__